import { memo, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";

import { useUserStore } from "stores/UserStore";

import { RemoveLoader } from "layouts/components/RemoveLoader";
import { SpecialThing } from "layouts/components/SpecialThing";

import CelebrationOverlay from "components/CelebrationOverlay";

import LoaderModal from "./components/LoaderModal";

// -----------------------------------------------------------------------------

const NoNavLayout = memo(function NoNavLayout({
  requireNoAuth,
}: Props): JSX.Element {
  const [userStore] = useUserStore();
  const navigate = useNavigate();

  const [renderContent, setRenderContent] = useState(false);

  //
  useEffect(
    () =>
      requireNoAuth && userStore.user.uuid !== ""
        ? navigate("/analytics")
        : setRenderContent(true),
    [userStore, requireNoAuth, navigate]
  );

  //
  return renderContent ? (
    <>
      <SpecialThing />
      <CelebrationOverlay />
      <Box sx={{ width: "100%", height: "100%" }}>
        <Box
          sx={{
            backgroundColor: "#1F6BBC",
            color: "#fff",
            display: "flex",
            height: "100%",
            padding: 2,
            width: "100%",
          }}
        >
          <RemoveLoader />
          <Outlet />
        </Box>
      </Box>
    </>
  ) : (
    <LoaderModal />
  );
});

export default NoNavLayout;

// -----------------------------------------------------------------------------

interface Props {
  requireNoAuth: boolean;
}
